<div class="flex items-center">
  <button (click)="backPath()" class="p-0 border-none cursor-pointer" [disabled]="loading">
    <span nz-icon nzType="left-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#f06a21'"></span>
  </button>
</div>
